import type { Translate } from "i18n/types";

export const CURRENCY_SEGMENT_TYPES = {
  CRYPTO: "CRYPTO",
  STABLECOINS: "STABLECOINS",
  CURRENCY: "CURRENCY"
};
export const getCurrencySegmentOptions = (
  t: Translate<"converter">
): { type: string; localizedName: string }[] => {
  return [
    { type: CURRENCY_SEGMENT_TYPES.CRYPTO, localizedName: t("crypto") },
    {
      type: CURRENCY_SEGMENT_TYPES.STABLECOINS,
      localizedName: t("stablecoins")
    },
    { type: CURRENCY_SEGMENT_TYPES.CURRENCY, localizedName: t("fiat") }
  ];
};
